import React, { useRef, lazy, Suspense } from 'react';
import * as R from 'ramda';
import { useSelector } from 'react-redux';
import { getLocale } from '../selectors/router';

const ReCAPTCHA = lazy(() => import('react-google-recaptcha'));

export const Captcha = ({ callback = R.identity }) => {
  const captchaRef = useRef();
  const locale = useSelector(getLocale);

  return (
    <Suspense>
      <ReCAPTCHA
        ref={captchaRef}
        theme={'light'}
        sitekey={window.CONFIG.captchaSiteKey}
        onChange={callback}
        hl={locale}
      />
    </Suspense>
  );
};
